/**
 * request.js
 * 通过promise对axios做二次封装，针对用户端参数，做灵活配置
 */
import store from '/@/vuex/index.js'
import { Loading } from 'element-ui'
import { Message } from 'element-ui'
import { Toast } from 'vant'
import service from './interceptor'
import { getSessionStorage } from '/@/utils/storage'
/**
 * 核心函数，可通过它处理一切请求数据，并做横向扩展
 * @param {url} 请求地址
 * @param {params} 请求参数
 * @param {options} 请求配置，针对当前本次请求；
 * @param loading 是否显示loading
 * @param error 本次是否显示错误
 */
const request = (url, params, options = { loading: true, error: true }, method) => {
  let loadingInstance
  // 请求前loading
  if (options.loading) {
    loadingInstance = Loading.service({
      lock: true,
      text: '拼命加载中',
      background: 'rgba(0, 0, 0, 0.1)'
    })
  }

  // 打印请求信息
  // console.group('请求信息')
  // console.log('请求URL:', url)
  // console.log('请求方法:', method)
  // console.log('请求参数:', params)
  // console.log('请求配置:', options)
  // console.groupEnd()

  return new Promise((resolve, reject) => {
    let data = {}
    // 从sessionStorage获取token
    const token = sessionStorage.getItem('token')
    const headers = {
      'Authorization': token || '',
      'X-Requested-With': 'XMLHttpRequest'
    }

    // 打印请求信息，方便调试
    // console.log('Request URL:', url)
    // console.log('Request Headers:', headers)

    // get请求使用params字段
    if (method === 'get') data = { params }
    // post请求使用data字段
    if (method === 'post') data = { data: params }

    service({
      url,
      method,
      headers,
      ...data
    })
      .then(res => {
        // 关闭loading
        if (options.loading) {
          loadingInstance.close()
        }

        if (res.status === 200 && (res.data.code === 1 || res.data.code === 200)) {
          resolve(res.data)
        } else if (res.data.code === 400 || res.data.code === 401) {
          // token错误，需重新登录
          if (options.error) Message.error(res.data.msg || '请先登录')
          // 清除token
          sessionStorage.removeItem('token')
          setTimeout(() => {
            store.dispatch('user/logout')
          }, 1500)
          reject(res.data)
        } else {
          // 其他业务错误，直接返回错误信息
          if (options.error && res.data.msg) {
            Message.error(res.data.msg)
          }
          resolve(res.data)
        }
      })
      .catch(err => {
        // 关闭loading
        if (options.loading) {
          loadingInstance.close()
        }

        console.error('Request error:', err)
        // 显示错误信息
        if (options.error) {
          let errorMsg = '请求失败'
          if (err.response && err.response.data) {
            errorMsg = err.response.data.message || '服务器响应错误'
            // 如果是登录相关错误，清除token并跳转
            if (err.response.data.code === 400 || err.response.data.code === 401) {
              sessionStorage.removeItem('token')
              setTimeout(() => {
                store.dispatch('user/logout')
              }, 1500)
            }
          } else if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
            errorMsg = '请求超时，请检查网络连接'
          } else if (!err.response) {
            errorMsg = '网络请求失败，请检查网络连接'
          }
          Message.error(errorMsg)
        }

        reject(err)
      })
  })
}

/**
 * 核心函数，可通过它处理一切请求数据，并做横向扩展
 * @param {url} 请求地址
 * @param {params} 请求参数
 * @param {options} 请求配置，针对当前本次请求；
 * @param loading 是否显示loading
 * @param error 本次是否显示错误
 */
const requestApp = (url, params, options = { loading: true, error: true }, method) => {
  let loadingInstance
  // 请求前loading
  if (options.loading) {
    loadingInstance = Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 0
    })
  }
  return new Promise((resolve, reject) => {
    let data = {}
    const headers = { Authorization: getSessionStorage('token') }
    // get请求使用params字段
    if (method === 'get') data = { params }
    // post请求使用data字段
    if (method === 'post') data = { data: params }
    service({
      url,
      method,
      headers,
      ...data
    }).then((res) => {
      // 此处作用很大，可以扩展很多功能。
      // 比如对接多个后台，数据结构不一致，可做接口适配器
      // 也可对返回日期/金额/数字等统一做集中处理
      if (res.code === 200) {
        resolve(res)
      } else {
        // console.log(res)
        // 通过配置可关闭错误提示
        if (options.error) Toast.fail({ message: res.message })
        reject(res)
      }
    }).catch((error) => {
      // console.log(error)
      Toast.fail({ message: error.message })
    }).finally(() => {
      if (options.loading) loadingInstance.clear()
    })
  })
}
export { request, requestApp }
